import './LegalPage.css';

/**
 * Mentions Légales Page
 */
export const MentionsLegales = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-page__content">
          <h1 className="legal-page__title">Mentions Légales</h1>
          
          <section className="legal-page__section">
            <h2>Éditeur du site</h2>
            <p>
              <strong>Nom de la société :</strong> [À compléter]<br />
              <strong>Forme juridique :</strong> [À compléter]<br />
              <strong>Capital social :</strong> [À compléter]<br />
              <strong>Siège social :</strong> [À compléter]<br />
              <strong>SIRET :</strong> [À compléter]<br />
              <strong>Email :</strong> contact@bookiner.co<br />
              <strong>Directeur de la publication :</strong> [À compléter]
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Hébergement</h2>
            <p>
              <strong>Hébergeur :</strong> [À compléter]<br />
              <strong>Adresse :</strong> [À compléter]<br />
              <strong>Téléphone :</strong> [À compléter]
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de ce site (textes, images, vidéos, etc.) est protégé par le droit d'auteur.
              Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces différents éléments
              est strictement interdite sans l'accord exprès par écrit de Bookiner.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Responsabilité</h2>
            <p>
              Bookiner s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations diffusées sur ce site,
              dont elle se réserve le droit de corriger, à tout moment et sans préavis, le contenu.
              Toutefois, Bookiner ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Crédits</h2>
            <p>
              Les icônes utilisées sur ce site proviennent de <a href="https://www.flaticon.com" target="_blank" rel="noopener noreferrer" style={{color: 'var(--color-primary)', textDecoration: 'underline'}}>Flaticon</a> :
            </p>
            <ul>
              <li>
                <a href="https://www.flaticon.com/fr/icones-gratuites/livre-ouvert" title="livre ouvert icônes" target="_blank" rel="noopener noreferrer" style={{color: 'var(--color-primary)'}}>Livre ouvert icônes créées par Nuricon - Flaticon</a>
              </li>
              <li>
                <a href="https://www.flaticon.com/fr/icones-gratuites/litterature" title="littérature icônes" target="_blank" rel="noopener noreferrer" style={{color: 'var(--color-primary)'}}>Littérature icônes créées par Freepik - Flaticon</a>
              </li>
              <li>
                <a href="https://www.flaticon.com/fr/icones-gratuites/collaboration" title="collaboration icônes" target="_blank" rel="noopener noreferrer" style={{color: 'var(--color-primary)'}}>Collaboration icônes créées par Freepik - Flaticon</a>
              </li>
            </ul>
          </section>

          <a href="/" className="legal-page__back">← Retour à l'accueil</a>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
